<template>
      <div class="sellerCroact">
         <div class="manage-table">
            <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="false"  :rowKey="(record,index)=>{return index}" >
   
           </a-table>
         </div>   
      </div>  
</template>
<script>
const columns = [
   {
      title: '序号',
      dataIndex: 'projectCode',
      width: 200,
       customRender: (text,record,index) => `${index+1}`,
   },
   {
      title: '订单编号',
      dataIndex: 'orderNo',
   },
   {
      title: '联系人',
      dataIndex: 'nickName',
   },
    {
      title: '申诉原因',
      dataIndex: 'complaintReason',
   },
   {
      title: '申诉结果',
      dataIndex: 'complaintResult',
   }
]   
export default {
   data(){
       return{
           columns:columns,
           data:[],
           total:0,
           loading:false,
       }
   },
   created(){
      this.$parent.activeIndex = 5;
      this.getDataList();
   },
   methods:{
      getDataList(){
         this.loading = true;
         this.$https.get('/portal/complaint/complaintList').then(res=>{
            this.loading = false;
            if(res.code == 200){
               this.data = res.rows;
            }
         }).catch(error=>{
              this.loading = false;
         })
      },
   }
}
</script>
<style lang="less" scoped>

</style>

